import React from "react";
import { useQuickSightEFS  } from "@/hooks/useEFSReports";

const QuickSightAwsEFSDashboard = () => {
  const { embedUrl } = useQuickSightEFS ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsEFSDashboard;
